/**
 *
 * ModalDeleteAllQuestions
 *
 */

import React from "react"
// import PropTypes from 'prop-types';
import { Modal, Button } from "antd"
import alertSvg from "../../images/alert.svg"
import "./index.less"

/* eslint-disable react/prefer-stateless-function */
class ModalDeleteAllQuestions extends React.Component {
  render() {
    const unUsed = (
      <div className="modal-delete-container">
        <img src={alertSvg} className="alertIcon" />
        <span
          style={{
            fontWeight: 600,
            fontSize: 14,
            marginTop: 16,
            marginBottom: 15,
            textAlign: "center",
          }}>
          ¿Estás seguro de que deseas eliminar todas las preguntas del
          cuestionario?
        </span>
        <p>Esta acción no es reversible.</p>
      </div>
    )

    const used = (
      <div className="modal-delete-container">
        <img src={alertSvg} className="alertIcon" />
        <p
          style={{
            fontWeight: 600,
            fontSize: 14,
            marginTop: 16,
            marginBottom: 15,
            textAlign: "center",
          }}>
          ¿Estás seguro de que deseas eliminar todas las preguntas del
          cuestionario? <br />
          <span style={{ marginTop: 10 }}>
            ¡Se perderá el análisis histórico!
          </span>
        </p>
        <p style={{ textAlign: "center" }}>
          Este cuestionario ha sido utilizado en{" "}
          <strong>{this.props.measures}</strong> mediciones en el sistema. Al
          eliminar sus preguntas, se{" "}
          <span style={{ textDecoration: "underline" }}>
            perderá la oportunidad de analizar su resultado histórico.
          </span>
        </p>
        <p style={{ textAlign: "center" }}>
          Recuerda que también es posible <strong>editarlas</strong>{" "}
          directamente en la plataforma, de tal forma que el histórico no se vea
          afectado.
        </p>
      </div>
    )
    return (
      <Modal
        visible={this.props.visible}
        style={{ top: 76 }}
        closable={false}
        footer={[
          <Button
            key="back"
            onClick={() =>
              this.props.setStateFrom("modalDeleteAllQuestions", false)
            }>
            Cancelar
          </Button>,
          <Button
            key="submit"
            type="primary"
            onClick={() => {
              const { itemId } = this.props
              this.props.deleteItem(itemId)
              this.props.forceReload(true)
            }}>
            Eliminar
          </Button>,
        ]}
        width={520}>
        {this.props.measures === 0 ? unUsed : used}
      </Modal>
    )
  }
}

ModalDeleteAllQuestions.propTypes = {}

export default ModalDeleteAllQuestions
